import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { fetchMyStatus, fetchUser } from "../../api/api";
import { getUserId } from "../../utils/cookieUtils";
import MyPoints from "../../components/MyPoints/MyPoints";
import MyTraining from "../../components/MyTraining/MyTraining";

/**
 * Training page: the employee's points and status, then their assigned modules.
 * Clicking an unread post opens Home filtered to that post so it can be read there.
 */
const Training = () => {
    const navigate = useNavigate();
    const [myStatus, setMyStatus] = useState(null);
    const [user, setUser] = useState(null);

    useEffect(() => {
        let cancelled = false;

        // Failures are ignored on purpose: the card just stays hidden if points
        // are turned off for this company or unavailable.
        fetchMyStatus()
            .then(({ data }) => !cancelled && setMyStatus(data ?? null))
            .catch(() => !cancelled && setMyStatus(null));

        const userId = getUserId();
        if (userId) {
            fetchUser(userId)
                .then(({ data }) => !cancelled && setUser(data ?? null))
                .catch(() => {});
        }

        return () => {
            cancelled = true;
        };
    }, []);

    const openPost = useCallback(
        (post) => {
            navigate(`/dashboard/home?search=${encodeURIComponent(post.title)}`);
        },
        [navigate]
    );

    return (
        <Box sx={{ width: "100%", maxWidth: 900, mx: "auto", px: { xs: 2, sm: 3 }, py: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
                Training
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
                Your points and assigned modules. Open a module to see which posts are left to read.
            </Typography>

            {/* Reading points and status. Renders nothing when turned off. */}
            <MyPoints
                status={myStatus}
                profileImage={user?.profile_image}
                name={user ? `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim() : ""}
                email={user?.email}
            />

            <MyTraining standalone onOpenPost={openPost} />
        </Box>
    );
};

export default Training;
